import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "segment"]

  connect() {
    this.update()
  }

  update() {
    const value = this.inputTarget.value || ""
    const score = this.#score(value)
    this.segmentTargets.forEach((seg, i) => {
      seg.classList.toggle("on", i < score)
    })
  }

  #score(v) {
    let s = 0
    if (v.length >= 8) s++
    if (/[A-Z]/.test(v) && /[a-z]/.test(v)) s++
    if (/\d/.test(v)) s++
    if (/[^A-Za-z0-9]/.test(v)) s++
    return s
  }
}
